var React = require('react');

function LinkMail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame"},React.createElement("path",{"id":"Vector","d":"M3.0013 2.5H18.0013C18.4616 2.5 18.8346 2.8731 18.8346 3.33333V16.6667C18.8346 17.1269 18.4616 17.5 18.0013 17.5H3.0013C2.54107 17.5 2.16797 17.1269 2.16797 16.6667V3.33333C2.16797 2.8731 2.54107 2.5 3.0013 2.5ZM10.5518 9.73575L5.20732 5.19808L4.12862 6.46858L10.5622 11.9309L16.88 6.46347L15.7893 5.2032L10.5518 9.73575Z","fill":"#16233C"})));
}

LinkMail.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = LinkMail;

LinkMail.default = LinkMail;
